import { useState } from 'react'

import { Modal } from '../../../components/ui'
import { Button, Meta } from '../../../components/ui/legacy'
import useGetBookByUUID from './hooks/useGetBookByUUID'
import { CoverNotAvailbale } from '../../../assets/images'
import { Icon } from '@iconify/react'
import useGetAccountByUUID from '../../../features/account-management/account-list/hooks/useGetAccountById'
import { facultyService } from '../../../service/FacultyService'
import { useEffect } from 'react'
import { formatSeconds } from '../../../service/BookBorrowServiceNew'
function BookCover({ cover }) {
  const handleImageError = (e) => {
    e.target.src = CoverNotAvailbale
  }
  return (
    <figure className="mt-4 items-center">
      <img
        src={cover}
        alt="Ảnh bìa"
        className="h-[72vh] w-full rounded-lg object-cover"
        onError={handleImageError}
      />
    </figure>
  )
}
function BookSummary({ content, closeHandler }) {
  const formattedContent = content.split('\\n').map((line, index) => (
    <p key={index} className="mb-2">
      {line}
    </p>
  ))

  return (
    <Modal
      onClose={closeHandler}
      className="text-md z-50 w-[500px] rounded-lg bg-white p-6 text-gray-accent shadow-lg"
    >
      {formattedContent}
    </Modal>
  )
}
function BookDetailModal({ uuid, closeHandler }) {
  const { data, isLoading } = useGetBookByUUID(uuid)
  const { data: uploaderData, isLoading: isLoadingUploader } =
    useGetAccountByUUID(data?.uploader)
  const [facultyName, setFacultyName] = useState('')
  useEffect(() => {
    const fetchFaculty = async () => {
      const res = await facultyService.getAll()
      setFacultyName(
        res.message.content.find((f) => f.uuid === data?.faculty)?.name ||
          'Không xác định'
      )
    }
    fetchFaculty()
  }, [data?.faculty])
  const [summary, setSummary] = useState(false)

  const closeSummaryHandler = () => {
    setSummary(!summary)
  }

  if (isLoading) {
    return
  }
  return (
    <Modal
      onClose={() => {
        closeHandler()
      }}
      className={'w-[900px] rounded-lg bg-white p-6 shadow-lg'}
    >
      {summary ? (
        <BookSummary
          content={data.description}
          closeHandler={closeSummaryHandler}
        />
      ) : null}
      <div className="flex gap-5">
        <BookCover cover={data?.cover} />
        <section className="mt-4 w-2/3 text-gray-accent">
          <div>
            <div className="mb-2 flex gap-2">
              <span
                className={`rounded bg-secondarygray px-4 py-1 font-bold text-white`}
              >
                GIÁO TRÌNH
              </span>
              {!data?.borrow ? (
                <></>
              ) : (
                <div className="group relative">
                  <span
                    className={`flex cursor-help flex-row gap-1 rounded bg-secondarygray px-3 py-1 font-bold text-white`}
                  >
                    SÁCH MƯỢN TRẢ
                    <Icon
                      icon="clarity:exclamation-circle-line"
                      className="text-2xl"
                    />
                  </span>
                  <div className="absolute left-0 top-full z-50 mt-2 hidden group-hover:block">
                    <div className="relative w-64 rounded-lg border border-gray-200 bg-white p-3 shadow-lg">
                      <div className="absolute -top-2 left-4 h-4 w-4 rotate-45 transform border-l border-t border-gray-200 bg-white"></div>
                      <p className="mb-2 text-sm text-gray-accent">
                        <span className="font-semibold">
                          Thời gian mượn tối đa:
                        </span>{' '}
                        {/* {data?.borrowInfo?.timeOfBorrow / (60 * 60) || '--'} giờ */}
                        {formatSeconds(data?.borrowInfo?.timeOfBorrow) || '--'}
                      </p>
                      <p className="text-sm text-gray-accent">
                        <span className="font-semibold">
                          Số lượt mượn tối đa:
                        </span>{' '}
                        {data?.borrowInfo?.numOfBorrow || '--'} lượt
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <h1 className="mb-2 text-xl font-semibold text-gray-secondary">
              {data.type ? data.type.toUpperCase() : ''}
            </h1>
            <p>
              <b className="text-3xl font-semibold">{data.title}</b>
            </p>
          </div>

          <ol className="mt-7 flex max-h-[60vh] flex-col justify-between gap-2 overflow-y-auto pr-2">
            <li>
              <Meta
                title={'Gói sách'}
                content={data.bookCollections.join(', ')}
              />
            </li>
            {!data?.borrow ? (
              <></>
            ) : (
              <>
                <li>
                  <Meta
                    title={'Số lượt mượn tối đa'}
                    content={`${data?.borrowInfo?.numOfBorrow || '--'} lượt`}
                  />
                </li>
                <li>
                  <Meta
                    title={'Thời gian mượn'}
                    content={
                      // data?.borrowInfo?.timeOfBorrow
                      //   ? `${data?.borrowInfo?.timeOfBorrow / (60 * 60)} giờ`
                      //   : '--'
                      formatSeconds(data?.borrowInfo?.timeOfBorrow) || '--'
                    }
                  />
                </li>
              </>
            )}
            <li>
              <Meta title={'Người tải'} content={uploaderData?.fullName} />
            </li>
            <li>
              <Meta title={'Tác giả'} content={data.author} />
            </li>
            <li>
              <Meta title={'Năm xuất bản'} content={data.publishYear} />
            </li>
            <li>
              <Meta title={'Nhà xuất bản'} content={data.publisher} />
            </li>
            <li>
              <Meta title={'Khoa/ viện'} content={facultyName} />
            </li>
            <li>
              <Meta title={'Chuyên ngành'} content={data.major} />
            </li>
            <li>
              <Meta title={'Học phần'} content={data.subject} />
            </li>
            <li>
              <Meta title={'Số trang'} content={data.pages} />
            </li>
            <li>
              <Meta title={'Kích thước'} content={data.fileSize} />
            </li>
            <li>
              <Meta title={'Ngày đăng tải'} content={data.uploadDate} />
            </li>

            <li className="flex gap-1 text-lg">
              <Meta title={'Tóm tắt'} />
              <span
                className="cursor-pointer text-gray-secondary underline"
                onClick={closeSummaryHandler}
              >
                Xem chi tiết
              </span>
            </li>
          </ol>
        </section>
      </div>
      <footer className="flex justify-end gap-4">
        <Button
          onClickHandler={() => {
            closeHandler()
          }}
          variant={'primary'}
          className="font-semibold"
        >
          Đóng
        </Button>
      </footer>
    </Modal>
  )
}

export default BookDetailModal
